var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"loading"}},[_c('i',{staticClass:"fal fa-circle-notch fa-spin fa-3x fa-fw text-info"})]):_c('div',[_c('Theme'),_vm._v(" "),_c('AboutClient')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }